import { Typography } from "@suraasa/placebo-ui"
import YoutubeIcon from "assets/icons/youtube-icon.svg"
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "components/ui/carousel"
import { useState } from "react"

import { testimonialCarouselList } from "./data"

interface TestimonialContainerProps {
  teacherName: string
  thumbnailText: string
  designation: string
  beforeText: string
  afterText: string
  videoLink: string
}

const TestimonialContainer: React.FC<TestimonialContainerProps> = ({
  teacherName,
  thumbnailText,
  designation,
  beforeText,
  afterText,
  videoLink,
}) => {
  const [showVideo, setShowVideo] = useState(false)

  return (
    <button
      onClick={() => setShowVideo(!showVideo)}
      className="flex h-full flex-col text-left"
    >
      {showVideo ? (
        <div className="flex w-full justify-center rounded-t-lg bg-[#121212]">
          <iframe
            src={videoLink.replace("youtu.be/", "youtube.com/embed/")}
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            height="200px"
          ></iframe>
        </div>
      ) : (
        <div className="flex h-[200px] w-full flex-col justify-between rounded-t-lg bg-[#121212] p-2">
          <div className="flex flex-row gap-1">
            <img src={YoutubeIcon} alt="YouTube Icon" />
            <Typography variant="strong" className="text-white">
              Watch {teacherName} Talk about her Journey
            </Typography>
          </div>

          <div className="flex flex-col gap-0.5">
            <Typography variant="title3" className="!tracking-wide text-white">
              {thumbnailText}
            </Typography>
            <Typography variant="title4" className="text-white">
              {teacherName}
            </Typography>
            <Typography variant="smallBody" className="text-white">
              {designation}
            </Typography>
          </div>
        </div>
      )}

      <div className="grow rounded-b-lg bg-onSurface-100 p-2">
        <Typography variant="preTitle" className="text-onSurface-500">
          Before
        </Typography>
        <Typography variant="body" className="text-onSurface-500">
          {beforeText}
        </Typography>
        <div className="h-2"></div>
        <Typography variant="preTitle" className="text-onSurface-800">
          After
        </Typography>
        <Typography variant="body" className="text-onSurface-800">
          {afterText}
        </Typography>
      </div>
    </button>
  )
}

const TestimonialCarousel = () => {
  const screenWidth = window.innerWidth < 400
  return (
    <Carousel opts={{ slidesToScroll: screenWidth ? 1 : 2 }}>
      <CarouselContent>
        {testimonialCarouselList.map(el => (
          <CarouselItem className="sm:basis-1/2" key={el.name}>
            <TestimonialContainer
              teacherName={el.name}
              thumbnailText={el.thumbnailText}
              beforeText={el.before}
              afterText={el.after}
              videoLink={el.videoLink}
              designation={el.designation}
            />
          </CarouselItem>
        ))}
      </CarouselContent>
      <CarouselPrevious className="hidden bg-black sm:flex" />
      <CarouselNext className="hidden bg-black sm:flex" />
    </Carousel>
  )
}

export default TestimonialCarousel
